import script from "./Testimonies.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonies.vue?vue&type=script&setup=true&lang=js"

import "./Testimonies.vue?vue&type=style&index=0&id=65989396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65989396"]])

export default __exports__